module.exports = __webpack_public_path__ + "static/media/insurance_item-01.5d9bdf5c.svg";